// extracted by mini-css-extract-plugin
export default {"container":"PractitionerDropdownSection_container__F8I2g","title":"PractitionerDropdownSection_title__um2TV"};